<template>
  <AdminLayout>
    <TeamMap />
  </AdminLayout>
</template>

<script>
import AdminLayout from '@/components/layouts/AdminLayout/index.vue';
import TeamMap from '../components/admin/TeamMap.vue';

export default {
  components: {
    AdminLayout,
    TeamMap,
  },
};
</script>
